import { useCallback } from 'react'
import { clearStorage } from '../utils'
import { useDispatch, useSelector } from 'react-redux'
import { logOut } from '../api/people'
import { useHistory } from 'react-router-dom'

export default function useAuth() {
  const summaryEmail = useSelector((state) => state.summaryEmail)
  const dispatch = useDispatch()
  const history = useHistory()

  const logOutAction = useCallback(() => {
    logOut()
    clearStorage()
    dispatch({ type: 'USER_LOGOUT' })
  }, [dispatch])

  const signOut = useCallback(() => {
    if (
      window.location.pathname.includes('/detail/summary-email/') &&
      summaryEmail.editingTextNumber > 0
    ) {
      window.alert(
        'There have some text editing unfinished! Please check the summary email page.'
      )
    } else {
      clearStorage()
      logOutAction()
      history.push('/sign-in')
    }
  }, [history, logOutAction])

  return {
    signOut
  }
}
